import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import BookingPage from "../pages/booking/page";
import ServiceDetailPage from "../pages/service-detail/page";
import ServicesPage from "../pages/services/page";
import AboutPage from "../pages/about/page";
import PricingPage from "../pages/pricing/page";
import TeamPage from "../pages/team/page";
import AdminLoginPage from "../pages/admin/LoginPage";
import AdminLayout from "../pages/admin/AdminLayout";
import RequireAuth from "../pages/admin/RequireAuth";
import AdminDashboardPage from "../pages/admin/DashboardPage";
import PagesContentPage from "../pages/admin/PagesContentPage";
import TreatmentsPage from "../pages/admin/TreatmentsPage";
import TeamAdminPage from "../pages/admin/TeamAdminPage";
import ReviewsPage from "../pages/admin/ReviewsPage";
import BookingsPage from "../pages/admin/BookingsPage";
import MediaPage from "../pages/admin/MediaPage";
import TranslationsPage from "../pages/admin/TranslationsPage";
import FooterContactPage from "../pages/admin/FooterContactPage";
import SeoPage from "../pages/admin/SeoPage";
import SettingsPage from "../pages/admin/SettingsPage";
import PageEditorPage from "../pages/admin/PageEditorPage";
import AdminSocialPage from "../pages/admin/SocialPage";
import NewsletterPage from "../pages/admin/NewsletterPage";
import AdminImagesPage from "../pages/admin/AdminImagesPage";
import DentalImplantsPage from "../pages/dental-implants/page";
import ImprintPage from "../pages/imprint/page";
import ContactPage from "../pages/contact/page";
import AgbPage from "../pages/agb/page";
import PrivacyPage from "../pages/privacy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/dental-implants",
    element: <DentalImplantsPage />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/services/:slug",
    element: <ServiceDetailPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/booking",
    element: <BookingPage />,
  },
  {
    path: "/team",
    element: <TeamPage />,
  },
  {
    path: "/imprint",
    element: <ImprintPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/agb",
    element: <AgbPage />,
  },
  {
    path: "/admin",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin",
    element: (
      <RequireAuth>
        <AdminLayout />
      </RequireAuth>
    ),
    children: [
      {
        path: "dashboard",
        element: <AdminDashboardPage />,
      },
      {
        path: "pages-content",
        element: <PagesContentPage />,
      },
      {
        path: "treatments",
        element: <TreatmentsPage />,
      },
      {
        path: "team-manage",
        element: <TeamAdminPage />,
      },
      {
        path: "reviews",
        element: <ReviewsPage />,
      },
      {
        path: "bookings",
        element: <BookingsPage />,
      },
      {
        path: "media",
        element: <MediaPage />,
      },
      {
        path: "translations",
        element: <TranslationsPage />,
      },
      {
        path: "footer-contact",
        element: <FooterContactPage />,
      },
      {
        path: "seo",
        element: <SeoPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "edit/:slug",
        element: <PageEditorPage />,
      },
      {
        path: "newsletter",
        element: <NewsletterPage />,
      },
      {
        path: "social",
        element: <AdminSocialPage />,
      },
      {
        path: "images",
        element: <AdminImagesPage />,
      },
    ],
  },
  // German URL aliases → redirect to the canonical routes
  { path: "/kontakt", element: <Navigate to="/contact" replace /> },
  { path: "/leistungen", element: <Navigate to="/services" replace /> },
  { path: "/preise", element: <Navigate to="/pricing" replace /> },
  { path: "/ueber-uns", element: <Navigate to="/about" replace /> },
  { path: "/termin", element: <Navigate to="/booking" replace /> },
  { path: "/galerie", element: <Navigate to="/gallery" replace /> },
  { path: "/impressum", element: <Navigate to="/imprint" replace /> },
  { path: "/datenschutz", element: <Navigate to="/privacy" replace /> },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;